document.addEventListener("DOMContentLoaded", function () {
	const getElementHeight = (selector) => +$(selector).outerHeight(true);

	(function () {
		// Collection Breadcrumbs section
		const $collectionBreadcrumbs = $(".collection-breadcrumbs");
		const $sectionBreadcrumbs = $(".breadcrumbs-section");

		const initBreadcrumbsSticky = () => {
			$collectionBreadcrumbs.css(
				"top",
				`${getElementHeight("header.gheader")}px`
			);
			$sectionBreadcrumbs.css("top", `${getElementHeight("header.gheader")}px`);
		};

		const initBreadcrumbsScroll = () => {
			let sections = document.querySelectorAll("section");
			let links = document.querySelectorAll(".breadcrumbs-nav a");

			window.onscroll = () => {
				sections.forEach((section) => {
					let top = window.scrollY;
					let offset = section.offsetTop - 300;
					let height = section.offsetHeight;
					let id = section.getAttribute("id");

					if (top >= offset && top < offset + height) {
						links.forEach((link) => {
							link.classList.remove("active");

							const activeLink = document.querySelector(
								`.breadcrumbs-nav a[href*="${id}"]`
							);

							if (activeLink) {
								activeLink.classList.add("active");
							}
						});
					}
				});
			};
		};

		initBreadcrumbsSticky();
		initBreadcrumbsScroll();
	})();
	(function () {
		$(".navigation-dropdown .navigation-select").on(
			"click",
			".placeholder",
			function () {
				var parent = $(this).closest(".navigation-select");
				if (!parent.hasClass("is-open")) {
					parent.addClass("is-open");
					$(".select.is-open").not(parent).removeClass("is-open");
				} else {
					parent.removeClass("is-open");
				}
			}
		);
	})();
});
